import { Dispatch, useCallback } from "react";
import { useCancelHeldEmailAction } from "../../../hooks/admin/useHeldEmailBulkAction";
import {
  HeldEmailQueueAction,
  HeldEmailQueueState,
} from "../../../hooks/admin/useHeldEmailQueueState";
import { ConfirmCancelHeldEmailsModal } from "./ConfirmCancelHeldEmailsModal";

interface Props {
  state: HeldEmailQueueState;
  dispatch: Dispatch<HeldEmailQueueAction>;
}

export function HeldEmailCancelDialog({ state, dispatch }: Props) {
  const action = useCancelHeldEmailAction(state, dispatch);
  const close = useCallback(
    () => dispatch({ type: "action", value: null }),
    [dispatch]
  );
  const count =
    state.pendingAction?.type === "cancel" ? state.pendingAction.ids.length : 0;
  return (
    <ConfirmCancelHeldEmailsModal
      count={count}
      loading={action.mutation.isPending}
      onClose={close}
      onConfirm={action.confirm}
      opened={state.pendingAction?.type === "cancel"}
    />
  );
}
